module.exports = __webpack_public_path__ + "static/media/rainbow.8c81808d.svg";